import React from "react";
import { Button } from "../Components/UI/Button";
import {
  ViewandExportReportBtnContainer,
  ViewBtnsContainer,
} from "../../../fall-analysis/FallAnalysisReport";
import { FaBell } from "react-icons/fa6";
import styled from "styled-components";

interface QueryModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  onSubscribeClicked: any;
}

const ActBtn = styled.button`
  color: #b580ff;
  border: 1px solid #d9d9d9;
  background-color: #fff;
  cursor: pointer;
`;

export const QueryModal: React.FC<QueryModalProps> = ({
  isOpen,
  onClose,
  children,
  onSubscribeClicked,
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Modal */}
      <div className="fixed inset-0 isolate" style={{ zIndex: 9999 }}>
        {/* Backdrop */}
        <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />

        {/* Modal Container */}
        <div className="absolute inset-0 flex items-center justify-center p-4 sm:p-6 md:p-8">
          {/* Modal Content */}
          <div className="relative flex h-[97vh] w-[97%] max-w-full flex-col overflow-hidden rounded-xl bg-white-main shadow-2xl ring-1 ring-black/5">
            {/* Header */}
            <ViewandExportReportBtnContainer className="mt-10 flex items-end justify-between border-b px-6">
              <h2 className="font-bold text-gray-900">Generated Report</h2>
              <ViewBtnsContainer className="mr-2 flex gap-3">
                <div className="flex gap-2">
                  <ActBtn
                    className="text-white h-10 rounded px-4 py-2 text-sm disabled:opacity-50"
                    onClick={() => {
                      onClose();
                      onSubscribeClicked();
                    }}
                  >
                    <FaBell /> Subscribe
                  </ActBtn>
                </div>
                <Button
                  onClick={onClose}
                  className="flex h-10 w-10 cursor-pointer select-none items-center justify-center rounded-lg border-0 bg-gray-100 text-gray-600 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-400"
                >
                  ✕
                </Button>
              </ViewBtnsContainer>
            </ViewandExportReportBtnContainer>

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-6">{children}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QueryModal;
